import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import moment from 'moment';
import $ from '../jquery.js';
//import '../jquery-components/date-range-picker';
//import '../jquery-components/date-range-picker/date-range-picker.css';
import { BootstrapInput } from 'react-components/BootstrapInput';
import { useSnackbar } from 'notistack';
import { language, _T } from '../appI18n';
import _ from 'lodash';
const shouldAvoidMobileKeyboard = () => {
    var _a;
    return typeof window !== 'undefined'
        && ((window.matchMedia && window.matchMedia('(pointer: coarse)').matches)
            || ((_a = navigator.maxTouchPoints) !== null && _a !== void 0 ? _a : 0) > 0);
};
export function DateRangePickerField(props) {
    var _a;
    const snackbar = useSnackbar();
    const minDate = useMemo(() => { var _a; return !((_a = props.validDates) === null || _a === void 0 ? void 0 : _a.length) ? moment().add(1, 'd') : _.minBy(props.validDates.map(d => moment(d, 'YYYY-MM-DD')), d => d.unix()); }, [props.validDates]);
    const [[startDate, endDate], setDates] = useState([props.dates[0] ? moment(props.dates[0]) : undefined, props.dates[1] ? moment(props.dates[1]) : undefined]);
    const [errors, setErrors] = useState([]);
    const inputRef = useRef(null);
    const daterangepickerApply = useCallback((e, picker) => {
        if (props.dateLimit && picker.endDate.diff(picker.startDate, "days") >= props.dateLimit) {
            snackbar.enqueueSnackbar(props.dateLimitAlertText, { variant: 'warning', autoHideDuration: 5000 });
            //e.preventDefault();
            //picker.show();
            //return;
        }
        setDates([picker.startDate, picker.endDate]);
        if (props.onChange)
            props.onChange([picker.startDate, picker.endDate]);
        //$('#checkInDateStart').val(picker.startDate.format('YYYY-MM-DD'));
        //$('#checkInDateEnd').val(picker.endDate.format('YYYY-MM-DD'));
    }, [props.onChange]);
    useEffect(() => {
        if (!inputRef.current)
            return;
        const calendarLocale = moment.localeData(language);
        $(inputRef.current).daterangepicker({
            locale: {
                format: calendarLocale.longDateFormat('L'),
                daysOfWeek: calendarLocale.weekdaysMin(),
                monthNames: calendarLocale.months(),
                firstDay: calendarLocale.firstDayOfWeek(),
                applyLabel: _T.COMMON_ACTION_APPLY,
                cancelLabel: _T.COMMON_CANCEL_2,
                weekLabel: _T.COMMON_WEEK,
                customRangeLabel: _T.COMMON_SELECT_DATES,
            },
            startDate: !props.dates[0] ? minDate : moment(props.dates[0]),
            endDate: !props.dates[1] ? minDate : moment(props.dates[1]),
            dateLimit: props.dateLimit,
            //startDate: moment($('#checkInDateStart').val()),
            //endDate: moment($('#checkInDateEnd').val()),
            minDate: minDate,
            autoApply: true,
            isInvalidDate: function (date) {
                // Вычеркивает даты которые не попадают в список разрешенных дат заезда.
                var s = date.format('YYYY-MM-DD');
                if (props.validDates === undefined) {
                    console.trace('CheckIn date set is undefined');
                    return false;
                }
                return props.validDates.indexOf(s) < 0;
                /*
                if (g_currentTourId === null) {
                    // Если тур не выбран ищем по разрешенным датам всех туров.
                    var dateSets = Object.values(g_validCheckInDates);

                    for (var i = 0; i < dateSets.length; ++i) {
                        if (dateSets[i].has(s))
                            return false;
                    }
                } else {
                    var dateSet = g_validCheckInDates[g_currentTourId];
                    if (dateSet === undefined) {
                        console.error('CheckIn date set for selected tour (' + g_currentTourId + ') is undefined');
                        return false;
                    }

                    return !dateSet.has(s);
                }

                return true;
                */
            }
        });
        $(inputRef.current).off('apply.daterangepicker', daterangepickerApply);
        $(inputRef.current).on('apply.daterangepicker', daterangepickerApply);
        return () => {
        };
    }, [inputRef.current, ...props.dates, props.validDates, daterangepickerApply]);
    useEffect(() => {
        if (!props.validationCallback)
            return;
        const validationResult = props.validationCallback([startDate, endDate]);
        if (!validationResult)
            return;
        if (Array.isArray(validationResult))
            setErrors([...validationResult]);
        else
            setErrors([validationResult]);
    }, [startDate, endDate, props.validationCallback]);
    const valueLabel = useMemo(() => { var _a, _b, _c; return startDate && endDate ? (startDate.isSame(endDate) ? startDate.format((_a = props.displayFormat) !== null && _a !== void 0 ? _a : 'YYYY-MM-DD') : `${startDate.format((_b = props.displayFormat) !== null && _b !== void 0 ? _b : 'YYYY-MM-DD')} - ${endDate.format((_c = props.displayFormat) !== null && _c !== void 0 ? _c : 'YYYY-MM-DD')}`) : _T.COMMON_SELECT_DATES; }, [startDate, endDate]);
    const InputType = (_a = props.input) !== null && _a !== void 0 ? _a : BootstrapInput;
    const preventMobileKeyboard = () => {
        var _a;
        if (shouldAvoidMobileKeyboard())
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormControl, { fullWidth: true, variant: props.variant, error: props.error, disabled: props.disabled, className: props.className },
            React.createElement(InputLabel, { htmlFor: props.id, "data-shrink": "true", className: "MuiInputLabel-shrink" }, props.label),
            React.createElement(InputType, { disabled: props.disabled, id: props.id, className: `rangepicker-textbox`, ref: inputRef, value: valueLabel, readOnly: true, inputProps: {
                    readOnly: true,
                    inputMode: 'none',
                    style: { caretColor: 'transparent', cursor: 'pointer' }
                }, onFocus: preventMobileKeyboard, style: { caretColor: 'transparent', color: startDate && endDate ? undefined : 'rgba(0, 0, 0, 0.3)' } }),
            React.createElement(FormHelperText, { error: true, style: { display: errors.length ? 'unset' : 'none' } }, errors.map(e => React.createElement(React.Fragment, null,
                React.createElement("span", null, e),
                React.createElement("br", null)))))));
}
